import Vue from 'vue'
import moment from 'moment'

Vue.filter('longtime', function (val, tz = undefined) {
  if (tz)
  {
    return moment(val).tz(tz).format("h:mma MMMM DD, YYYY");
  }
  return moment(val).format('h:mma MMMM DD, YYYY')
})